import { render, staticRenderFns } from "./otherForm.vue?vue&type=template&id=e145dc72&scoped=true&"
import script from "./otherForm.vue?vue&type=script&lang=js&"
export * from "./otherForm.vue?vue&type=script&lang=js&"
import style0 from "./otherForm.vue?vue&type=style&index=0&id=e145dc72&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e145dc72",
  null
  
)

export default component.exports